import * as React from "react";
import Button from "../../components/common/Button";
import { NAVIGATION } from "../../lib/navigation";
import Input from "../../components/common/Input";
import { useNavigate } from "react-router-dom";
import useApiRequest from '../../store/slices/hook/useApiRequest';
import { login, setLoginData } from "../../store/slices/api/auth/loginSlice";
import logo from '../../assets/images/logo_new.png'

export default function LoginPage() {
    const navigate = useNavigate();

    const afterAPICall = (response) => {
        navigate(NAVIGATION.INNER_NAVIGATION.DASHBOARD)
    }

    const { isLoading, control, handleSubmit } = useApiRequest({
        apiAction: login,
        setValueAction: setLoginData,
        afterAPICall,
    });
    return (
        <div className="w-full bg-gray-300 h-screen pt-32">
            <div className='w-full max-w-md mb-16 mx-auto bg-white p-6 rounded'>
                <div className='w-full text-center'>
                    <img src={logo} className="h-9 mx-auto" alt="The Grad Story Logo" />
                    <p className="mt-6 text-lg font-semibold">Admin login</p>
                </div>
                <div className='w-full'>
                    <form onSubmit={handleSubmit}>
                        <Input
                            control={control}
                            name="email"
                            rules={{
                                required: "Email is required"
                            }}
                            type="email"
                            label="Email"
                        />
                        <Input
                            control={control}
                            name="password"
                            rules={{
                                required: "Password is required"
                            }}
                            type="password"
                            label="Password"
                        />
                        <Button isLoading={isLoading} className="w-full my-6">
                            Sign in
                        </Button>
                    </form>
                    <div className="w-full text-center">
                        <p className="text-gray-500"><small>&copy; TheGradStory | All Rights Reserved - 2024</small></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

